import { OrganizationReportOperationEntity } from '../entities/';
import { authResource } from './Auth';
import { schema } from '@data-client/rest';
export const OrganizationReportOperationResource = authResource({
    path: '/organizations/:organizationId/reports/operations/:operationId?',
    searchParams: {},
    schema: OrganizationReportOperationEntity
}).extend('getList', {
    schema: {
        count: 0,
        items: new schema.Collection([OrganizationReportOperationEntity])
    }
});
